var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserMultiple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#multi-users-icon)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.9705,
    cy: 9.54632,
    r: 2.53167,
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90723 17.704C6.90723 15.529 8.6704 13.7659 10.8454 13.7659H13.0958C15.2708 13.7659 17.0339 15.529 17.0339 17.704C17.0339 18.7915 16.1523 19.6731 15.0648 19.6731H8.8763C7.78881 19.6731 6.90723 18.7915 6.90723 17.704Z",
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5656,
    cy: 7.01469,
    r: 1.68779,
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1902 12.4999C16.1902 11.1017 17.3237 9.96826 18.7219 9.96826H20.4097C21.8079 9.96826 22.9413 11.1017 22.9413 12.4999C22.9413 13.199 22.3746 13.7658 21.6755 13.7658H17.456C16.7569 13.7658 16.1902 13.199 16.1902 12.4999Z",
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.37553,
    cy: 7.01469,
    r: 1.68779,
    fill: "#FEEFD7",
    stroke: "#976821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 12.4999C1 11.1017 2.13347 9.96826 3.53168 9.96826H5.21947C6.61767 9.96826 7.75114 11.1017 7.75114 12.4999C7.75114 13.199 7.18441 13.7658 6.4853 13.7658H2.26584C1.56674 13.7658 1 13.199 1 12.4999Z",
    fill: "#FEEFD7",
    stroke: "#976821"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "multi-users-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMultiple);
export default __webpack_public_path__ + "static/media/user--multiple.f9749fba.svg";
export { ForwardRef as ReactComponent };